<template>
  <div v-if="pageDocument" class="page">
    <blocks
      v-if="pageDocument.blocks"
      :blocks="pageDocument.blocks"
      :origin="ORIGIN.PAGE"
      is-on-top-of-page
    />
  </div>
</template>

<script>
import ScrollTrackingMixin from '@/mixins/ScrollTrackingMixin'
import Blocks from '@/components/blocks/Blocks'
import services from '@/services'
import { ORIGIN } from '@/const'

export default {
  name: 'Page',
  components: {
    Blocks,
  },
  mixins: [ScrollTrackingMixin],
  async asyncData({ payload, params, i18n, $logError, error }) {
    let pageDocument

    if (payload && payload.pageDocument) {
      pageDocument = payload.pageDocument
    } else {
      try {
        // Query to get post content
        pageDocument = await services.sanityService
          .getPage({
            uid: params.uid,
            lang: i18n.locale.slice(0, 2),
          })
          .then((res) => {
            if (res.length > 0) {
              return res[0]
            }

            return null
          })

        if (!pageDocument) {
          throw new Error('page-not-found')
        }
      } catch (e) {
        // Returns error page
        // if (e.message !== 'page-not-found') {
        $logError.captureException(e)
        // }
        return error({ statusCode: 404, message: 'Page not found' })
      }
    }

    // Returns data to be used in template
    return {
      pageDocument,
    }
  },
  data() {
    return {
      pageDocument: null,
      ORIGIN,
    }
  },
  head() {
    if (this.pageDocument) {
      const route = `${
        process.env.BASE_URL ? process.env.BASE_URL : 'https://www.asphalte.com'
      }${this.$nuxt.$route.path}`

      const head = services.pageService.getHead(
        {
          type: 'website',
          title: this.pageDocument.title,
          route,
          sanity: this.pageDocument,
          defaultTitle: this.$t('seo.defaultTitle'),
          defaultDesc: this.$t('seo.defaultDesc'),
        },
        this.$generateAlternateLinksMetaSanity(
          this.pageDocument._type,
          this.pageDocument.alternate_languages
        )
      )

      return head
    }

    return {}
  },
  mounted() {
    this.$track.page(this.$metaInfo, this.$route, this.$nuxt.context.from)
  },
}
</script>
